// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import getAdditionalAntennas from './getAdditionalAntennas'
import getPrimaryAntennaCode from './getPrimaryAntennaCode'

const scrubAntennas = (site, unitType) => ({
  additional: getAdditionalAntennas(site.segmentEndAntennas, unitType),
  primary: getPrimaryAntennaCode(site.segmentEndAntennas),
})

export default scrubAntennas
